// extracted by mini-css-extract-plugin
module.exports = {"lightning":"Lightning_lightning__30IHT","lightining":"Lightning_lightining__3n8jo","lightining-background":"Lightning_lightining-background__2WBjO"};